import { render, staticRenderFns } from "./pkg-tag.vue?vue&type=template&id=11d7394c"
import script from "./pkg-tag.vue?vue&type=script&lang=js"
export * from "./pkg-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports